import { isEmpty, isEmptyOrUndf } from 'features/shared/helpers/objects';
import React from 'react';
import ContactPersonDTO from 'features/contractualAccounts/dtos/ContactPersonDTO';
import { useInjection } from 'infrastructure/ioc/ioc.react';
import IContentDialogService from 'features/shared/components/contentDialog/IContentDialogService';
import { IocTypes } from 'infrastructure/ioc/ioc.types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import ContactDTO from 'features/customer/dtos/ContactDTO';
import Contact from 'features/customer/components/Contact';
import { useTranslation } from 'react-i18next';

interface Props {
  person: ContactPersonDTO;
}

const ContactPerson = ({ person }: Props) => {
  // translations
  const t = useTranslation("contractualAccounts\\contractualAccounts").t;

  // DI
  const dialogService = useInjection<IContentDialogService>(IocTypes.ContentDialogService);

  // handlers
  const openContactsDialogHandler = () => {
    dialogService.openDialog(t("contactPerson.contactsDialogTitle"), 
    () => (<div className="p-3">{renderContacts(person.contacts!)}</div>));
  };

  // sub-renders
  const renderShowContactsBtn = () => {
    if (person.contacts && person.contacts.length > 0) {
      return (
        <span role="button" className="ml-1 text-secondary" onClick={openContactsDialogHandler}>
          <FontAwesomeIcon icon="info-circle"  />
        </span>
      );
    }    
  }

  const renderContacts = (contacts: ContactDTO[]): JSX.Element[] => {
    return contacts.map((contact, index) => 
      <Contact contact={contact} key={index} />
    )
  }

  // render
  if (!isEmptyOrUndf(person)) {
    return (
      <>
        <span>{person.firstname} {person.lastname}</span>
        {renderShowContactsBtn()}
      </>
    ); 
  }
  return <>-</>
}

export default ContactPerson;
